import React, {useEffect, useState} from 'react';
import {Button} from '@mui/material';

const SearchComponent = ({onSearch, searched, setSearched, onClear, placeholder}) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = () => {
    onSearch(searchTerm);
    setSearched(true);
  };

  const handleClear = () => {
    setSearchTerm('');
    onClear();
    setSearched(false);
  };

  useEffect(() => {
    if (searchTerm === '') {
      setSearched(false);
    }
  }, [searchTerm]);

  return (
    <div style={{display: 'flex', alignItems: 'center'}}>
      <input
        type="text"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder={placeholder}
        style={{padding: '7px', fontSize: '16px', width: '200px'}}
      />
      {searched ? (
        <Button variant={'outlined'} color={'error'} onClick={handleClear}>
          Clear
        </Button>
      ) : (
        <Button
          variant={'contained'}
          sx={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
          onClick={handleSearch}
          disabled={searchTerm.trim() === ''}
        >
          Search
        </Button>
      )}
    </div>
  );
};

export default SearchComponent;